module.exports = __webpack_public_path__ + "img/gy9.29f24058.png";